"use client"

import { ReactQueryProvider } from "@/components/react-query-provider"
import { AuthProvider } from "@/components/auth-provider"
import { SSOHandler } from "@/components/sso-handler"
import { I18nextProvider } from 'react-i18next';
import i18n from "@/i18n";
import { TabProvider } from "@/hooks/useTab";
import { useEffect } from "react";


export default function Providers({ children}: { children: React.ReactNode; }) {
  // Ensure language is synced from localStorage after mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage && (savedLanguage === "en" || savedLanguage === "am")) {
      i18n.changeLanguage(savedLanguage);
    }
  }, []);

  return (
      <I18nextProvider i18n={i18n}>

    <ReactQueryProvider>
      <TabProvider>
        <AuthProvider>
          <SSOHandler>
            {children}
          </SSOHandler>
        </AuthProvider>
      </TabProvider>
    </ReactQueryProvider>
     </I18nextProvider>
  )
}
